// extracted by mini-css-extract-plugin
module.exports = {"layout":"section-divider_layout__q2Jgl","heading":"section-divider_heading__ao0C9","graphic":"section-divider_graphic__cCY8p"};